import { SVGProps } from 'react';

export const NotesCommentsIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="16pt"
    height="16pt"
    version="1.1"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m75 9.2383h-50c-4.2422 0-8.3125 1.6875-11.312 4.6875s-4.6875 7.0703-4.6875 11.312v32c0 4.2461 1.6875 8.3164 4.6875 11.316s7.0703 4.6836 11.312 4.6836h16.359l16.152 15.922c1.0078 1.0156 2.3789 1.5898 3.8086 1.6016 0.78906 0.003906 1.5703-0.19141 2.2695-0.5625 1.6641-0.88672 2.6172-2.6953 2.4102-4.5703l-0.32812-12.391h9.3281c4.2422 0 8.3125-1.6836 11.312-4.6836s4.6875-7.0703 4.6875-11.316v-32c0-4.2422-1.6875-8.3125-4.6875-11.312s-7.0703-4.6875-11.312-4.6875zm8 48c0 2.125-0.84375 4.1602-2.3438 5.6602s-3.5352 2.3398-5.6562 2.3398h-13.461c-1.0781 0-2.1133 0.4375-2.8672 1.2109-0.75391 0.77344-1.1602 1.8203-1.1328 2.9023l0.23047 8.8398-12-11.789v-0.003906c-0.73828-0.73047-1.7305-1.1445-2.7695-1.1602h-18c-4.418 0-8-3.5781-8-8v-32c0-4.418 3.582-8 8-8h50c2.1211 0 4.1562 0.84375 5.6562 2.3438s2.3438 3.5352 2.3438 5.6562z"
      fill="currentcolor"
    />
  </svg>
);
